import {
  GameAction,
  INITIAL_STATE,
  gameReducer,
  type GameState,
} from "app/game/gameState";
import useResetableStorage, {
  STORAGE_KEY_PREFIX,
} from "app/utils/useResetableStorage";
import { createContext, useCallback, useContext, useReducer } from "react";

export function useGameReducer() {
  const serializer = (state: GameState): string => JSON.stringify(state);
  const deserializer = (value: string): GameState => JSON.parse(value);

  const [savedState, setSaveState] = useResetableStorage(
    `${STORAGE_KEY_PREFIX}_GAME_STATE`,
    INITIAL_STATE,
    { raw: false, serializer, deserializer },
  );

  const reducerLocalStorage = useCallback(
    (state: GameState, action: GameAction) => {
      const newState = gameReducer(state, action);
      setSaveState(newState);
      return newState;
    },
    [setSaveState],
  );

  return useReducer(reducerLocalStorage, savedState || INITIAL_STATE);
}

export const GameDispatchContext = createContext<React.Dispatch<GameAction>>(
  () => {},
);

export function useGameActionDispatch() {
  return useContext(GameDispatchContext);
}

export const GameContext = createContext<GameState>(INITIAL_STATE);

export function useGameState() {
  return useContext(GameContext);
}
